// 平台字段 t_pf_field.c_number_range 的协议："最小值,最大值"，闭区间，一侧留空表示不限，如 ",60"。
// 格式不合法按未配置处理，不拦提交。
export interface NumberRange {
  min?: number
  max?: number
}

const toBound = (text: string): number | null | undefined => {
  const trimmed = text.trim()
  if (trimmed === '') return undefined
  const num = Number(trimmed)
  return Number.isFinite(num) ? num : null
}

export const parseNumberRange = (range?: string): NumberRange | undefined => {
  if (!range) return undefined
  const parts = range.split(',')
  if (parts.length !== 2) return undefined
  const min = toBound(parts[0])
  const max = toBound(parts[1])
  if (min === null || max === null) return undefined
  if (min === undefined && max === undefined) return undefined
  return { min, max }
}

/** 超出范围时返回报错文案，否则返回 undefined；空值不校验。 */
export const checkNumberRange = (
  value: unknown,
  range: NumberRange | undefined,
  fieldName = '',
): string | undefined => {
  if (!range || value === undefined || value === null || value === '') return
  const num = Number(value)
  if (!Number.isFinite(num)) return
  const { min, max } = range
  const outOfRange =
    (min !== undefined && num < min) || (max !== undefined && num > max)
  if (!outOfRange) return
  if (min !== undefined && max !== undefined)
    return `${fieldName}须在${min}～${max}之间`
  return max !== undefined
    ? `${fieldName}不能大于${max}`
    : `${fieldName}不能小于${min}`
}
// 平台字段 t_pf_field.c_number_range 的协议："最小值,最大值"，闭区间，一侧留空表示不限，如 ",60"。
// 格式不合法按未配置处理，不拦提交。
export interface NumberRange {
  min?: number
  max?: number
}

const toBound = (text: string): number | null | undefined => {
  const trimmed = text.trim()
  if (trimmed === '') return undefined
  const num = Number(trimmed)
  return Number.isFinite(num) ? num : null
}

export const parseNumberRange = (range?: string): NumberRange | undefined => {
  if (!range) return undefined
  const parts = range.split(',')
  if (parts.length !== 2) return undefined
  const min = toBound(parts[0])
  const max = toBound(parts[1])
  if (min === null || max === null) return undefined
  if (min === undefined && max === undefined) return undefined
  return { min, max }
}

/** 超出范围时返回报错文案，否则返回 undefined；空值不校验。 */
export const checkNumberRange = (
  value: unknown,
  range: NumberRange | undefined,
  fieldName = '',
): string | undefined => {
  if (!range || value === undefined || value === null || value === '') return
  const num = Number(value)
  if (!Number.isFinite(num)) return
  const { min, max } = range
  const outOfRange =
    (min !== undefined && num < min) || (max !== undefined && num > max)
  if (!outOfRange) return
  if (min !== undefined && max !== undefined)
    return `${fieldName}须在${min}～${max}之间`
  return max !== undefined
    ? `${fieldName}不能大于${max}`
    : `${fieldName}不能小于${min}`
}
